import { render } from "./GamePerformanceTableMobile.vue?vue&type=template&id=4b21c00e&scoped=true"
import script from "./GamePerformanceTableMobile.vue?vue&type=script&lang=js"
export * from "./GamePerformanceTableMobile.vue?vue&type=script&lang=js"

import "./GamePerformanceTableMobile.vue?vue&type=style&index=0&id=4b21c00e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\reportpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b21c00e"]])

export default __exports__